import React from 'react'

const PrivacyPolicy = () => {
  return (
    <div className='min-h-screen flex flex-col bg-background'>
      <main className='flex-grow container mx-auto px-4 py-8'>
        <h1 className='text-3xl font-bold text-text-primary mb-6'>
          Política de Privacidad
        </h1>

        <div className='bg-card p-6 rounded-lg shadow-sm'>
          <p className='text-text-secondary mb-4'>
            Última actualización: 23 de marzo de 2025
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            1. Introducción
          </h2>
          <p className='text-text-secondary mb-4'>
            En Conversor IAE CNAE ("nosotros", "nuestro", "el Sitio") nos
            comprometemos a proteger tu privacidad. Esta Política de Privacidad
            explica cómo recopilamos, utilizamos, compartimos y protegemos la
            información personal que obtenemos a través de nuestro sitio web
            conversoriaecnae.es y sus subdominios.
          </p>
          <p className='text-text-secondary mb-4'>
            Al utilizar nuestro Sitio, aceptas las prácticas descritas en esta
            Política de Privacidad. Te animamos a leerla detenidamente para
            entender nuestro enfoque respecto a tu información.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            2. Información que Recopilamos
          </h2>
          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            2.1 Información proporcionada voluntariamente
          </h3>
          <p className='text-text-secondary mb-4'>
            Recopilamos la siguiente información que nos proporcionas
            voluntariamente:
          </p>
          <ul className='list-disc pl-6 text-text-secondary mb-4'>
            <li className='mb-2'>
              <strong>Dirección de correo electrónico:</strong> cuando te
              suscribes a nuestra newsletter.
            </li>
            <li className='mb-2'>
              <strong>Consultas y mensajes:</strong> información que nos
              proporcionas cuando nos contactas por email.
            </li>
            <li className='mb-2'>
              <strong>Comentarios:</strong> información compartida en nuestra
              comunidad de Reddit vinculada al Sitio.
            </li>
          </ul>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            2.2 Información recopilada automáticamente
          </h3>
          <p className='text-text-secondary mb-4'>
            Recopilamos cierta información automáticamente cuando visitas
            nuestro Sitio:
          </p>
          <ul className='list-disc pl-6 text-text-secondary mb-4'>
            <li className='mb-2'>
              <strong>Información de uso:</strong> cómo interactúas con nuestro
              Sitio, incluyendo páginas visitadas, tiempo de permanencia y
              patrones de navegación.
            </li>
            <li className='mb-2'>
              <strong>Información técnica:</strong> dirección IP, tipo de
              navegador, proveedor de servicios de Internet, identificadores de
              dispositivos, sistema operativo y otra información técnica
              similar.
            </li>
            <li className='mb-2'>
              <strong>Cookies y tecnologías similares:</strong> utilizamos
              cookies y tecnologías similares para mejorar la experiencia del
              usuario, analizar tendencias y administrar el Sitio. Para más
              información, consulta nuestra sección sobre cookies.
            </li>
          </ul>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            2.3 Búsquedas y conversiones de códigos
          </h3>
          <p className='text-text-secondary mb-4'>
            Registramos información sobre las búsquedas y conversiones de
            códigos IAE y CNAE realizadas en nuestro Sitio con el fin de mejorar
            nuestro servicio y proporcionar sugerencias más relevantes a todos
            los usuarios.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            3. Cómo Utilizamos tu Información
          </h2>
          <p className='text-text-secondary mb-4'>
            Utilizamos la información recopilada para:
          </p>
          <ul className='list-disc pl-6 text-text-secondary mb-4'>
            <li className='mb-2'>
              <strong>Proporcionar nuestros servicios:</strong> ofrecer acceso y
              funcionalidad al conversor de códigos IAE-CNAE y directorios
              relacionados.
            </li>
            <li className='mb-2'>
              <strong>Comunicaciones:</strong> enviar nuestra newsletter si te
              has suscrito a ella, responder a tus consultas y proporcionarte
              información importante sobre nuestros servicios.
            </li>
            <li className='mb-2'>
              <strong>Mejora del servicio:</strong> comprender cómo utilizas
              nuestro Sitio para mejorar su funcionamiento, características y
              contenido.
            </li>
            <li className='mb-2'>
              <strong>Análisis y estadísticas:</strong> analizar tendencias de
              uso, monitorizar la eficacia de nuestro Sitio y realizar
              investigaciones para mejorar nuestros servicios.
            </li>
            <li className='mb-2'>
              <strong>Cumplimiento legal:</strong> cumplir con obligaciones
              legales y regulatorias aplicables.
            </li>
          </ul>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            4. Protección de Datos y No Compartición con Terceros
          </h2>
          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            4.1 Nuestro compromiso
          </h3>
          <p className='text-text-secondary mb-4'>
            Protegemos tu privacidad y no compartimos tus datos personales con
            terceros para fines de marketing o comerciales.
          </p>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            4.2 Excepciones limitadas
          </h3>
          <p className='text-text-secondary mb-4'>
            Podemos compartir información en las siguientes circunstancias
            limitadas:
          </p>
          <ul className='list-disc pl-6 text-text-secondary mb-4'>
            <li className='mb-2'>
              <strong>Proveedores de servicios:</strong> podemos proporcionar
              información a terceros de confianza que nos ayudan a operar
              nuestro Sitio, como proveedores de alojamiento web (Supabase) y
              servicios de análisis. Estos proveedores tienen acceso limitado a
              tu información y están obligados contractualmente a utilizarla
              solo para proporcionarnos los servicios solicitados.
            </li>
            <li className='mb-2'>
              <strong>Cumplimiento legal:</strong> podemos divulgar información
              si creemos de buena fe que hacerlo es necesario para cumplir con
              la ley, proteger nuestros derechos o en respuesta a una orden
              judicial o proceso legal.
            </li>
            <li className='mb-2'>
              <strong>Consentimiento:</strong> con tu consentimiento explícito.
            </li>
          </ul>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            5. Seguridad de la Información
          </h2>
          <p className='text-text-secondary mb-4'>
            Implementamos medidas de seguridad técnicas, administrativas y
            físicas diseñadas para proteger la información personal contra
            pérdida, uso indebido y acceso no autorizado, divulgación,
            alteración o destrucción.
          </p>
          <p className='text-text-secondary mb-4'>
            Sin embargo, ninguna transmisión por Internet o método de
            almacenamiento electrónico es 100% seguro. Por lo tanto, no podemos
            garantizar su seguridad absoluta.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            6. Tus Derechos sobre tus Datos Personales
          </h2>
          <p className='text-text-secondary mb-4'>
            De acuerdo con la legislación de protección de datos aplicable,
            tienes los siguientes derechos:
          </p>
          <ul className='list-disc pl-6 text-text-secondary mb-4'>
            <li className='mb-2'>
              <strong>Acceso:</strong> derecho a solicitar una copia de tus
              datos personales.
            </li>
            <li className='mb-2'>
              <strong>Rectificación:</strong> derecho a solicitar la corrección
              de datos inexactos o incompletos.
            </li>
            <li className='mb-2'>
              <strong>Supresión:</strong> derecho a solicitar la eliminación de
              tus datos personales en determinadas circunstancias.
            </li>
            <li className='mb-2'>
              <strong>Limitación del tratamiento:</strong> derecho a solicitar
              la restricción del procesamiento de tus datos.
            </li>
            <li className='mb-2'>
              <strong>Portabilidad de datos:</strong> derecho a recibir tus
              datos personales en un formato estructurado y de uso común.
            </li>
            <li className='mb-2'>
              <strong>Oposición:</strong> derecho a oponerte al tratamiento de
              tus datos en determinadas circunstancias.
            </li>
            <li className='mb-2'>
              <strong>Retirada del consentimiento:</strong> derecho a retirar tu
              consentimiento en cualquier momento.
            </li>
          </ul>
          <p className='text-text-secondary mb-4'>
            Para ejercer cualquiera de estos derechos, puedes contactarnos a
            través de contacto@conversoriaecnae.es.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            7. Política de Cookies
          </h2>
          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            7.1 ¿Qué son las cookies?
          </h3>
          <p className='text-text-secondary mb-4'>
            Las cookies son pequeños archivos de texto que se almacenan en tu
            dispositivo cuando visitas nuestro Sitio. Utilizamos cookies y
            tecnologías similares para mejorar la experiencia del usuario,
            analizar tendencias y administrar el Sitio.
          </p>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            7.2 Tipos de cookies que utilizamos
          </h3>
          <ul className='list-disc pl-6 text-text-secondary mb-4'>
            <li className='mb-2'>
              <strong>Cookies esenciales:</strong> necesarias para el
              funcionamiento básico del Sitio.
            </li>
            <li className='mb-2'>
              <strong>Cookies analíticas:</strong> nos ayudan a comprender cómo
              interactúas con nuestro Sitio mediante la recopilación de
              información anónima.
            </li>
            <li className='mb-2'>
              <strong>Cookies funcionales:</strong> permiten recordar elecciones
              que haces para proporcionarte funcionalidades mejoradas y
              personalizadas.
            </li>
          </ul>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            7.3 Control de cookies
          </h3>
          <p className='text-text-secondary mb-4'>
            Puedes configurar tu navegador para rechazar todas o algunas
            cookies, o para alertarte cuando los sitios web establezcan o
            accedan a las cookies. Si desactivas o rechazas las cookies, ten en
            cuenta que algunas partes de este Sitio pueden volverse inaccesibles
            o no funcionar correctamente.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            8. Menores de Edad
          </h2>
          <p className='text-text-secondary mb-4'>
            Nuestro Sitio no está dirigido a personas menores de 16 años y no
            recopilamos deliberadamente información personal de menores. Si eres
            padre/madre o tutor y crees que tu hijo nos ha proporcionado
            información personal, contáctanos y tomaremos medidas para eliminar
            esa información de nuestros registros.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            9. Enlaces a Sitios Web de Terceros
          </h2>
          <p className='text-text-secondary mb-4'>
            Nuestro Sitio puede contener enlaces a sitios web de terceros,
            incluida nuestra comunidad en Reddit. Esta Política de Privacidad no
            se aplica a esos sitios web y no somos responsables de las prácticas
            de privacidad de terceros. Te recomendamos revisar las políticas de
            privacidad de cualquier sitio web que visites.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            10. Cambios en esta Política de Privacidad
          </h2>
          <p className='text-text-secondary mb-4'>
            Podemos actualizar nuestra Política de Privacidad de vez en cuando.
            Te notificaremos cualquier cambio material publicando la nueva
            Política de Privacidad en esta página y, si los cambios son
            significativos, proporcionaremos un aviso más prominente o te
            enviaremos una notificación por correo electrónico.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            11. Conservación de Datos
          </h2>
          <p className='text-text-secondary mb-4'>
            Conservamos tu información personal solo durante el tiempo necesario
            para los fines establecidos en esta Política de Privacidad, a menos
            que se requiera o permita un período de retención más largo por ley.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            12. Transferencias Internacionales de Datos
          </h2>
          <p className='text-text-secondary mb-4'>
            Nuestro Sitio opera principalmente en España. Sin embargo, los datos
            que recopilamos pueden ser almacenados y procesados en cualquier
            país donde tengamos operaciones o donde estén ubicados nuestros
            proveedores de servicios. Al utilizar nuestro Sitio, aceptas
            cualquier transferencia de información fuera de tu país.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            13. Contacto
          </h2>
          <p className='text-text-secondary mb-4'>
            Si tienes preguntas o inquietudes sobre esta Política de Privacidad
            o nuestras prácticas de privacidad, contáctanos en:
          </p>
          <ul className='list-disc pl-6 text-text-secondary mb-4'>
            <li className='mb-2'>
              <strong>Email:</strong> contacto@conversoriaecnae.es
            </li>
            <li className='mb-2'>
              <strong>Comunidad:</strong>{' '}
              <a
                href='https://www.reddit.com/r/ConversorIAE_CNAE/'
                className='text-primary hover:underline'
              >
                https://www.reddit.com/r/ConversorIAE_CNAE/
              </a>
            </li>
          </ul>
          <p className='text-text-secondary mb-4'>
            Esta Política de Privacidad fue actualizada por última vez en la
            fecha indicada al principio de este documento.
          </p>
        </div>
      </main>
    </div>
  )
}

export default PrivacyPolicy
